import { render } from "./SearchMenu.vue?vue&type=template&id=64bc9f5a&scoped=true"
import script from "./SearchMenu.vue?vue&type=script&lang=js"
export * from "./SearchMenu.vue?vue&type=script&lang=js"

import "./SearchMenu.vue?vue&type=style&index=0&id=64bc9f5a&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bc9f5a"]])

export default __exports__